var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { paths } from "frontend/src/pages/paths";
import { Role } from "frontend/src/shared/types/role";
import { TracksPage } from "./tracks/index";
import { EditTrackPage } from "./tracks/edit/page";
import { UploadTracksPage } from "./tracks/upload/page";
import { PlaylistsPage } from "./playlists/index";
import { EditPlaylistPage } from "./playlists/edit/page";
import { MusicArchivesPage } from "./music-archives/index";
import { EditMusicArchivePage } from "./music-archives/edit/page";
import { ClientsPage } from "./clients/index";
import { ViewClientPage } from "./clients/view";
import { PlaylistBusinessTypesPage } from "./playlist-business-types/view-any";
import { GenresPage } from "./genres";
import { LogsPage } from "./logs";
import { SettingsPage } from "./settings";
export var adminRoutes = [
    {
        path: paths.admin.tracks.index(),
        Component: TracksPage,
        roles: [Role.Admin, Role.MusicEditor],
    },
    {
        path: paths.admin.tracks.edit(":id"),
        Component: EditTrackPage,
        roles: [Role.Admin, Role.MusicEditor],
    },
    {
        path: paths.admin.tracks.upload(),
        Component: UploadTracksPage,
        roles: [Role.Admin, Role.MusicEditor],
    },
    {
        path: paths.admin.playlists.index(),
        Component: PlaylistsPage,
        roles: [Role.Admin, Role.MusicEditor],
    },
    {
        path: paths.admin.playlists.edit(":id"),
        Component: EditPlaylistPage,
        roles: [Role.Admin, Role.MusicEditor],
    }, {
        path: paths.admin.musicArchives.index(),
        Component: MusicArchivesPage,
        roles: [Role.Admin, Role.MusicEditor],
    },
    {
        path: paths.admin.musicArchives.edit(":id"),
        Component: EditMusicArchivePage,
        roles: [Role.Admin, Role.MusicEditor],
    },
    {
        path: paths.admin.clients.index(),
        Component: ClientsPage,
        roles: [Role.Admin],
    },
    {
        path: paths.admin.clients.view(":id"),
        Component: ViewClientPage,
        roles: [Role.Admin],
    },
    {
        path: paths.admin.playlistsBusinessTypes.viewAny(),
        Component: PlaylistBusinessTypesPage,
        roles: [Role.Admin, Role.MusicEditor],
    },
    {
        path: paths.admin.genres.index(),
        Component: GenresPage,
        roles: [Role.Admin, Role.MusicEditor],
    },
    {
        path: paths.admin.logs.index(),
        Component: LogsPage,
        roles: [Role.Admin],
    },
    {
        path: paths.admin.settings.index(),
        Component: SettingsPage,
        roles: [Role.Admin],
    },
].map(function (route) { return (__assign(__assign({}, route), { role: Role.Admin })); });
